module.exports = __webpack_public_path__ + "static/media/PAYU.3f735e2d.svg";